import React from 'react'

export default function EditableWatchList({ funds, classList }) {
  const renderFundClasses = (classes) => {
    return classList.map((className) => {
      return classes.map((info) => {
        if (info.class == className) {
          return (
            <div key={info.cusip} className="Checkbox">
              <input
                type="checkbox"
                className="Checkbox-button class-selection"
                name={info.symbol}
                id={info.cusip}
                value={info.cusip}
              ></input>
              <label className="Checkbox-label" htmlFor={info.cusip}>
                {info.class}
              </label>
            </div>
          )
        } else {
          return null
        }
      })
    })
  }

  return (
    <div id="watch-list-edittable">
      <p className="Content">Select funds to display</p>
      <div className="Table-overflowWrapper u-paddingRight2gu">
        <table className="Table">
          <thead className="Table-head">
            <tr className="Table-row">
              <th
                className="Table-header"
                style={{ height: 'auto' }}
                colSpan={3}
              >
                Fund Name Class
              </th>
            </tr>
          </thead>
          <tbody className="Table-body">
            {funds.map((fund) => {
              if (!fund.classes || fund.classes.length < 1) {
                return null
              }

              return (
                <tr
                  key={fund.categoryName + fund.fundName}
                  className="Table-row"
                >
                  <td
                    className="Table-cell u-padding2gu"
                    style={{ verticalAlign: 'middle' }}
                  >
                    <div className="u-textColorBrand u-textBold watch-list-header">
                      {fund.fundName}
                    </div>
                    <div className="u-flex">
                      {renderFundClasses(fund.classes)}
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
